module.exports = __webpack_public_path__ + "static/media/whatsapp.73af98a1.png";